module.exports = __webpack_public_path__ + "img/title-right-line.9b435e61.png";